/* LADA — Travel set landing page.
   1) Odkazy href="#TravelSetContact" s data-ts-topic (interest | meeting | b2b | question) zaškrtnou záměr,
      data-ts-set předvolí sadu (CORE / FULL) a stránka sjede na formulář.
   2) Panely formuláře se ukazují podle záměru: zájem o sadu (sada, velikost, barva), B2B (firma, web).
   3) Validace: aspoň jeden záměr, jméno a e-mail povinné, zpráva povinná jen u dotazu. Při chybě zůstávají údaje.
   4) Novinky nejsou součástí formuláře (rozhodnutí Mariana 29. 10. 2026): přihlášení je v patičce webu (odkaz K-11).
   6) K-05: select barvy – kombinace se berou ze seznamů barev v dialozích sad ([data-ts-set-colors], jediný zdroj =
      editor) a filtrují podle zvolené sady; „Ještě nevím“ a „jiná“ jsou skutečné hodnoty a změna sady je nezahodí.
   7) K-22: CTA uvnitř dialogu sady (theme.js data-modal) dialog nejdřív zavře, pak předvolí sadu a sjede na formulář.
   5) Měření přes window.ladaTrack (souhlas řeší theme.js): travel_set_cta, travel_set_lead.
   Do analytiky nikdy nejdou osobní údaje – jen kód akce, záměr, sada a jazyk. Skript se načte jednou. */
(function () {
  if (window.ladaTravelSet) return;
  window.ladaTravelSet = true;

  var STORE = 'lada-travel-set-lead';
  var lang = document.documentElement.lang || '';

  function track(cta, extra) {
    if (typeof window.ladaTrack !== 'function') return;
    var data = { cta: cta, lang: lang };
    if (extra) for (var k in extra) if (extra[k]) data[k] = extra[k];
    window.ladaTrack('travel_set_cta', data);
  }
  function rootUrl() {
    var r = window.ladaTheme && window.ladaTheme.routes && window.ladaTheme.routes.root;
    if (!r) r = '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function init() {
    var section = document.getElementById('TravelSetContact');
    var form = section && section.querySelector('[data-ts-form]');
    var success = section && section.querySelector('[data-ts-success]');

    /* --- potvrzení po odeslání zprávy --- */
    if (success) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(STORE) || 'null'); sessionStorage.removeItem(STORE); } catch (e) {}
      if (saved) {
        if (saved.intents && saved.intents.indexOf('meeting') > -1) { var m = success.querySelector('[data-ts-success-meeting]'); if (m) m.hidden = false; }
        if (typeof window.ladaTrack === 'function') {
          window.ladaTrack('travel_set_lead', { intent: (saved.intents || []).join('+'), set: saved.set || '', lang: lang });
        }
      }
      success.focus();
    }

    var intents = form ? form.querySelectorAll('input[data-intent]') : [];
    var sets = form ? form.querySelectorAll('input[data-set]') : [];
    var color = form && form.querySelector('[data-ts-color]');
    var panels = form ? form.querySelectorAll('[data-ts-panel]') : [];
    var subject = form && form.querySelector('[data-ts-subject]');
    var source = form && form.querySelector('[data-ts-source]');
    var name = form && form.querySelector('#TsName');
    var email = form && form.querySelector('#TsEmail');
    var body = form && form.querySelector('#TsBody');
    var intentError = form && form.querySelector('[data-ts-intent-error]');
    var nameError = form && form.querySelector('[data-ts-name-error]');
    var emailError = form && form.querySelector('[data-ts-email-error]');
    var bodyError = form && form.querySelector('[data-ts-body-error]');
    var bodyOptional = form && form.querySelector('[data-ts-body-optional]');
    var submit = form && form.querySelector('[data-ts-submit]');
    var errors = section && section.querySelector('[data-ts-errors]');

    function checkedIntents() {
      var out = [];
      for (var i = 0; i < intents.length; i++) if (intents[i].checked) out.push(intents[i].getAttribute('data-intent'));
      return out;
    }
    function selectedSet() { for (var i = 0; i < sets.length; i++) if (sets[i].checked) return sets[i].getAttribute('data-set'); return ''; }
    function fieldError(el, errEl, on) {
      if (!el) return;
      if (errEl) errEl.hidden = !on;
      var wrap = el.closest('.ts-field'); if (wrap) wrap.classList.toggle('has-error', on);
      if (on) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
    }
    function syncIntent() {
      var list = checkedIntents();
      var interest = list.indexOf('interest') > -1;
      var question = list.indexOf('question') > -1;
      panels.forEach(function (p) { p.hidden = list.indexOf(p.getAttribute('data-ts-panel')) === -1; });
      if (subject) subject.value = subject.getAttribute(interest ? 'data-subject-interest' : 'data-subject-message');
      if (body) { if (question) body.setAttribute('required', ''); else body.removeAttribute('required'); }
      if (bodyOptional) bodyOptional.hidden = question;
      if (!question) fieldError(body, bodyError, false);
      if (list.length && intentError) intentError.hidden = true;
      if (submit && submit.getAttribute('aria-busy') !== 'true') submit.textContent = submit.getAttribute(interest ? 'data-label-interest' : 'data-label-message');
    }
    function setIntent(code) {
      for (var i = 0; i < intents.length; i++) if (intents[i].getAttribute('data-intent') === code) intents[i].checked = true;
      syncIntent();
    }
    function setSet(name) {
      if (!name) return;
      var key = String(name).trim().toUpperCase();
      for (var i = 0; i < sets.length; i++) {
        var v = sets[i].value.toUpperCase();
        if (key.indexOf(v) === 0 || v.indexOf(key) === 0) { sets[i].checked = true; syncColors(); return; }
      }
    }
    /* --- K-05: barevné kombinace podle sady --- */
    function colorGroups() {
      var out = [];
      var lists = document.querySelectorAll('[data-ts-set-colors]');
      for (var i = 0; i < lists.length; i++) {
        var items = [];
        var lis = lists[i].querySelectorAll('li');
        for (var j = 0; j < lis.length; j++) { var t = lis[j].textContent.replace(/\s+/g, ' ').trim(); if (t) items.push(t); }
        if (items.length) out.push({ code: lists[i].getAttribute('data-ts-set-colors') || '', label: lists[i].getAttribute('data-ts-set-label') || '', items: items });
      }
      return out;
    }
    var groups = colorGroups();
    function syncColors() {
      if (!color || !groups.length) return;
      var current = color.value;
      var setCode = selectedSet();
      var other = color.querySelector('[data-ts-color-other]');
      var old = color.querySelectorAll('optgroup[data-ts-dyn], option[data-ts-color-posted]');
      for (var i = 0; i < old.length; i++) color.removeChild(old[i]);
      var available = false;
      for (var g = 0; g < groups.length; g++) {
        if (setCode && setCode !== 'unknown' && groups[g].code !== setCode) continue;
        var og = document.createElement('optgroup');
        og.label = groups[g].label || groups[g].code.toUpperCase();
        og.setAttribute('data-ts-dyn', '');
        for (var k = 0; k < groups[g].items.length; k++) {
          var o = document.createElement('option');
          o.value = groups[g].items[k]; o.textContent = groups[g].items[k];
          if (o.value === current) available = true;
          og.appendChild(o);
        }
        color.insertBefore(og, other || null);
      }
      var unknown = color.querySelector('[data-ts-color-unknown]');
      if (available || (other && current === other.value) || (unknown && current === unknown.value)) color.value = current;
      else if (unknown) color.value = unknown.value;
    }
    function validate() {
      var list = checkedIntents();
      var okIntent = list.length > 0;
      if (intentError) intentError.hidden = okIntent;
      var okName = name && name.value.trim() !== '';
      var okEmail = email && email.value.trim() !== '' && email.checkValidity();
      var okBody = list.indexOf('question') === -1 || (body && body.value.trim() !== '');
      fieldError(name, nameError, !okName);
      fieldError(email, emailError, !okEmail);
      fieldError(body, bodyError, !okBody);
      if (!okIntent) { if (intents[0]) intents[0].focus(); return false; }
      if (!okName) { name.focus(); return false; }
      if (!okEmail) { email.focus(); return false; }
      if (!okBody) { body.focus(); return false; }
      return true;
    }
    function remember() {
      try { sessionStorage.setItem(STORE, JSON.stringify({ intents: checkedIntents(), set: selectedSet() })); } catch (e) {}
    }
    function busy(on) {
      if (!submit) return;
      if (on) { submit.setAttribute('aria-busy', 'true'); submit.classList.add('is-loading'); submit.textContent = submit.getAttribute('data-label-sending') || submit.textContent; }
      else { submit.removeAttribute('aria-busy'); submit.classList.remove('is-loading'); syncIntent(); }
    }
    /* Hlídač zaseknutého odeslání (B28-01, zpřísněno B30-04 / F-04): když po odeslání stránka do 12 s neodejde
       (ověření proti spamu selže bez hlášky – v konzoli „form submit failed challenge-error“), uvolní tlačítko,
       ukáže chybu s možností opakovat a údaje nechá vyplněné. Jediná výjimka: skutečně VIDITELNÉ okno ověření
       (hCaptcha puzzle) – pak ukáže pokyn „dokonči ověření“ a čeká dál, nejdéle 90 s. Dřívější kontrola jen podle
       rozměrů rámce selhávala: hCaptcha drží skrytý rámec o reálné velikosti, takže se čekalo 180 s bez zprávy. */
    var submitError = form && form.querySelector('[data-ts-submit-error]');
    var challengeHint = form && form.querySelector('[data-ts-challenge-hint]');
    var watchdog = null;
    var watchStarted = 0;
    var STUCK_LIMIT = 12000;
    var CHALLENGE_LIMIT = 90000;
    function elementShown(el) {
      while (el && el.nodeType === 1) {
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') < 0.05) return false;
        el = el.parentElement;
      }
      return true;
    }
    function challengeVisible() {
      var frames = document.querySelectorAll('iframe[src*="hcaptcha"], iframe[title*="aptcha"], iframe[src*="challenge"]');
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < frames.length; i++) {
        var r = frames[i].getBoundingClientRect();
        if (r.width < 100 || r.height < 100) continue;
        if (r.bottom <= 0 || r.right <= 0 || r.top >= vh || r.left >= vw) continue;
        if (elementShown(frames[i])) return true;
      }
      return false;
    }
    function clearWatch() { if (watchdog) { clearTimeout(watchdog); watchdog = null; } }
    function hideHint() { if (challengeHint) challengeHint.hidden = true; }
    function startWatch() {
      clearWatch();
      watchStarted = Date.now();
      watchdog = setTimeout(checkStuck, STUCK_LIMIT);
    }
    function failStuck() {
      busy(false);
      hideHint();
      if (submitError) {
        submitError.hidden = false;
        submitError.focus();
      }
      track('travel_set_submit_stuck');
    }
    function checkStuck() {
      watchdog = null;
      if (!submit || submit.getAttribute('aria-busy') !== 'true') { hideHint(); return; }
      var elapsed = Date.now() - watchStarted;
      if (elapsed < CHALLENGE_LIMIT && challengeVisible()) {
        if (challengeHint) challengeHint.hidden = false;
        watchdog = setTimeout(checkStuck, 2000);
        return;
      }
      failStuck();
    }
    window.ladaTravelSetWatchdog = { limit: STUCK_LIMIT, challengeLimit: CHALLENGE_LIMIT };

    if (form) {
      if (source && !source.value) {
        try {
          var q = new URLSearchParams(location.search);
          var parts = ['utm_source', 'utm_medium', 'utm_content'].map(function (k) { return q.get(k); }).filter(Boolean);
          source.value = parts.length ? parts.join(' / ') : 'web';
        } catch (e) { source.value = 'web'; }
      }
      intents.forEach(function (c) { c.addEventListener('change', syncIntent); });
      syncIntent();
      for (var si = 0; si < sets.length; si++) sets[si].addEventListener('change', syncColors);
      syncColors();
      if (name) name.addEventListener('input', function () { if (name.value.trim()) fieldError(name, nameError, false); });
      if (email) email.addEventListener('blur', function () { if (email.value) fieldError(email, emailError, !email.checkValidity()); });
      if (body) body.addEventListener('input', function () { if (body.value.trim()) fieldError(body, bodyError, false); });
      if (errors) errors.focus();

      form.addEventListener('submit', function (e) {
        /* Během odesílání se další submit ignoruje (opakovaný klik = žádná duplicitní zpráva). Ověření proti spamu
           Shopify po úspěchu odesílá formulář nativně bez události submit, takže ho tahle pojistka neblokuje
           (ověřeno ručním odesláním 29. 10. 2026). */
        if (submit && submit.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
        if (!validate()) { e.preventDefault(); return; }
        if (submitError) submitError.hidden = true;
        hideHint();
        remember();
        busy(true);
        startWatch(); /* běžné odeslání pokračuje; ověření proti spamu Shopify ho zachytí samo */
      });
      window.addEventListener('pagehide', clearWatch);
      window.addEventListener('pageshow', function () { clearWatch(); hideHint(); busy(false); });
    }

    /* --- odkazy na formulář a měření kliknutí --- */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a, button');
      if (!a) return;
      var cta = a.getAttribute('data-ts-track');
      var topic = a.getAttribute('data-ts-topic');
      var setName = a.getAttribute('data-ts-set');
      if (cta) track(cta, { topic: topic, set: setName });
      if (!topic || !section || a.getAttribute('href') !== '#TravelSetContact') return;
      var dialog = a.closest('[data-modal]');
      if (dialog && window.ladaDialog) window.ladaDialog.close(dialog);
      if (form) {
        setIntent(topic);
        if (setName) setSet(setName);
      }
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      section.focus({ preventScroll: true });
      if (history.replaceState) history.replaceState(null, '', '#TravelSetContact');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
